export default __webpack_public_path__ + "static/media/Group 2113.83209124.png";